module.exports = __webpack_public_path__ + "img/clipboard.aa75d686.svg";